export const tripStatus = {
    'CREATED': 'Создан',
    'COMPLETED': 'Завершен',
    'CANCELED': 'Отменен',
    'PLANNED': "Запланирован",
    'IN_PROGRESS': "В поездке"
}

export const TripStatus = ({ status }) => {
    let statusClass = ""
    if (status === 'CREATED' || status === 'PLANNED' || status === 'IN_PROGRESS') {
        statusClass = 'color-yellow'
    }
    if (status === 'COMPLETED') {
        statusClass = 'color-green'
    }
    if (status === 'CANCELED') {
        statusClass = 'color-gray'
    }
    return <div>
        <span className={`${statusClass}`}>{tripStatus[status]}</span>
    </div>
}
